module.exports = __webpack_public_path__ + "static/media/cerises.0401cf04.svg";